// ============================================
// components/LoadingSpinner.tsx
//
// 全屏 / 内联 加载指示器. 用品牌色.
// ============================================

interface Props {
  /** 显示在 spinner 下方的提示文字 */
  hint?: string;
  /** fullscreen=true 全屏居中带背景, false 仅 spinner */
  fullscreen?: boolean;
  /** small=true 用更小的 spinner (按钮内用) */
  small?: boolean;
}

export default function LoadingSpinner({ hint, fullscreen, small }: Props) {
  const size = small ? 'w-5 h-5 border-2' : 'w-12 h-12 border-4';
  const spinner = (
    <div
      className={`inline-block ${size} border-gold-600 border-t-transparent rounded-full animate-spin`}
      aria-label="加载中"
    />
  );

  if (!fullscreen) return spinner;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gold-700 to-gold-500 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="py-4">
          {spinner}
          {hint && <p className="text-gray-600 mt-4">{hint}</p>}
        </div>
      </div>
    </div>
  );
}
